import { render } from "./payreceipt.vue?vue&type=template&id=854bbdbe&scoped=true"
import script from "./payreceipt.vue?vue&type=script&lang=js"
export * from "./payreceipt.vue?vue&type=script&lang=js"

import "./payreceipt.vue?vue&type=style&index=0&id=854bbdbe&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854bbdbe"]])

export default __exports__